export default "/assets/images/easy-replacement.672793e756670098.png";